export const roundTo = (numero: number, decimales: number): number => {
  const eNum = Math.round(decimales);
  const subNum = +(numero + "e+" + eNum);
  return +(Math.round(subNum) + "e-" + eNum);
};
